import React from "react";
import { Link } from "react-router-dom";
import { LegalLayout, LegalSection } from "./LegalLayout";

export default function Terms() {
  return (
    <LegalLayout eyebrow="terms of use" title="The rules, in plain English." updated="Feb 2026">
      <p data-testid="terms-intro" className="text-foreground">
        Book Away connects <strong>businesses</strong> that have a last-minute
        opening with <strong>consumers</strong> nearby who want it. We keep the
        rules short so you can get on with your day.
      </p>

      <LegalSection title="What Book Away is (and isn't)">
        <p>
          We're a discovery tool. When a business posts an opening, we show it
          on the map. When you send a request, the business chooses to approve
          or decline it. We don't take payments, and we're not part of the
          transaction.
        </p>
        <p>
          Anything you pay the business happens directly with them, on their
          terms.
        </p>
      </LegalSection>

      <LegalSection title="Booking rules">
        <p>You can send a request to any opening whose start time is still in the future.</p>
        <p>
          Once a slot's start time has passed, the "Request to Book" button is
          disabled — no last-second bookings for appointments that have already
          started.
        </p>
        <p>
          Approvals are at the business's discretion. If they decline, you're
          free to book someone else — no penalty.
        </p>
      </LegalSection>

      <LegalSection title="Businesses: your responsibilities">
        <p>Post accurate slots. If it fills, mark it filled. If plans change, cancel it.</p>
        <p>
          Approve or decline within a reasonable time — consumers pick you
          because you're fast.
        </p>
        <p>
          Reviews from consumers are visible to everyone. We may hide reviews
          that violate our{" "}
          <Link to="/privacy" className="underline hover:text-foreground">
            content standards
          </Link>{" "}
          but we don't edit them.
        </p>
      </LegalSection>

      <LegalSection title="Consumers: keep it real">
        <p>Give a working phone number so the business can confirm.</p>
        <p>Show up. No-shows cost the business — repeated no-shows may get your number blocked.</p>
        <p>Reviews should reflect the visit. No spam, no impersonation, no personal attacks.</p>
      </LegalSection>

      <LegalSection title="If something goes wrong">
        <p>
          Disputes about the service (quality, timing, price) are between you
          and the business. We're happy to help mediate, but we're not the
          judge.
        </p>
        <p>
          If someone is misusing Book Away — fake listings, harassment,
          anything sketchy — email{" "}
          <a
            href="mailto:hello@bookaway.com.au"
            className="underline hover:text-foreground"
          >
            hello@bookaway.com.au
          </a>
          .
        </p>
      </LegalSection>

      <LegalSection title="Changes">
        <p>
          If we update these terms, we'll bump the "Last updated" date at the top and give you a heads-up on the dashboard. Keep using the app after that and you're accepting the new version.
        </p>
      </LegalSection>

      <p className="mono text-[11px] uppercase tracking-widest text-muted-foreground pt-4 border-t border-border">
        Questions? →{" "}
        <a
          href="mailto:hello@bookaway.com.au"
          className="text-foreground hover:text-[#C9A85F]"
        >
          hello@bookaway.com.au
        </a>
      </p>
    </LegalLayout>
  );
}
